/** Origin MS.Culture (không có `/api`) — dùng axios dev gọi thẳng khi bật NEXT_PUBLIC_*. */
export const resolveCultureApiOrigin = (): string => {
  const raw =
    process.env.NEXT_PUBLIC_CULTURE_API_ORIGIN?.trim() ||
    process.env.NEXT_PUBLIC_CULTURE_API_BASE_URL?.trim() ||
    process.env.CONFIG_NEXT_PUBLIC_CULTURE_API_BASE_URL?.trim() ||
    '';
  if (raw) {
    return raw.replace(/\/$/, '').replace(/\/api$/i, '');
  }
  // Dev mặc định: không gọi thẳng MS.Culture — axios dùng baseURL `/api`, Next rewrite (next.config.ts → CULTURE_BASE_URL).
  return '';
};

export const isVanHoaCultureApiPath = (url: string | undefined): boolean => {
  if (!url) return false;
  const path = url.startsWith('http') ? new URL(url, 'http://local').pathname : url;
  return /^\/v1\/(VH.*|vh.*|HanhViThenChot)\b/i.test(path);
};
